import * as React from "react";
import { Button, Divider, Form, Loader, Modal } from "semantic-ui-react";

import { ShareDocumentsMessageDto } from "@teamprevent/common/shareDocuments/models";
import { SharedDocuments } from "@teamprevent/common/shareDocuments/components/SharedDocuments";

import { Input } from "@neworbit/simpleui-input";

import { shareDocumentsApi } from "../shareDocumentsApi";

interface Props {
    ohCaseId: string;
    taskId: string;
    onCancel: () => void;
}

export const SharedDocumentsMessage: React.FunctionComponent<Props> = (props: Props) => {

    const [model, setModel] = React.useState<ShareDocumentsMessageDto>(null);
    const [modalOpen, setModalOpen] = React.useState<boolean>(true);

    const { ohCaseId, taskId } = props;

    const fileApiUrl = `/api/shareDocuments/${ohCaseId}/document`;

    React.useEffect(() => {
        return () => setModel(null);
    }, []);

    React.useEffect(() => {
        (async () => {
            if (ohCaseId && taskId) {
                const data = await shareDocumentsApi.get(ohCaseId, taskId);
                setModel(data);
            }
        })();
    }, [ohCaseId, taskId]);

    const onClose = () => {
        resetState();
        props.onCancel();
    };

    const resetState = () => {
        setModalOpen(false);
    };

    if (!model) {
        return <Loader active />;
    }

    return (
        <Modal open={modalOpen}>
            <Modal.Header content="Shared Documents" />
            <Modal.Content>
                <Form>
                    <Form.Field>
                        <Input.Checkbox
                            readOnly
                            value={model.acceptedByTheAssociate}
                            label="Associate has confirmed acceptance of Message and Documents"
                        />
                    </Form.Field>
                    <h4><strong>Message:</strong></h4>
                    <h4>{model.message}</h4>
                    <Divider hidden />
                    <Form.Field>
                        <SharedDocuments fileApiUrl={fileApiUrl} documents={model.documents} />
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Close" onClick={onClose} />
            </Modal.Actions>
        </Modal>
    );
};
